/* istanbul ignore file */

import { inject, Injectable } from '@angular/core';
import { Faro, getWebInstrumentations, initializeFaro, LogLevel } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { AuthService } from '@libs/shared/auth';
import { EnvironmentService, GrafanaFaroConfigModel } from '@libs/shared/common';
import { LiveUpdateService } from '@libs/shared/live-update';

@Injectable({ providedIn: 'root' })
export class GrafanaFaroService {
  private readonly liveUpdateService: LiveUpdateService = inject(LiveUpdateService);
  private readonly envService: EnvironmentService = inject(EnvironmentService);
  private readonly authService: AuthService = inject(AuthService);

  public init(serviceName: string): void {
    if (this.envService.type() === 'local') {
      return;
    }

    const faroConfig: GrafanaFaroConfigModel = this.envService.grafanaFaroConfig();

    const faro: Faro = initializeFaro({
      url: faroConfig.url,
      apiKey: faroConfig.secret,
      instrumentations: [...getWebInstrumentations(), new TracingInstrumentation()],
      consoleInstrumentation: {
        disabledLevels: [
          LogLevel.TRACE,
          LogLevel.DEBUG,
          LogLevel.LOG,
          LogLevel.INFO,
          LogLevel.WARN,
        ],
      },
      dedupe: true,
      app: {
        name: serviceName,
        version: this.liveUpdateService.getVersion(),
        environment: this.envService.type(),
        bundleId: this.envService.msalConfig().appId,
      },
      user: {
        username: '',
      },
    });

    faro.api.setSession(faro.api.getSession(), { overrides: { serviceName: serviceName } });

    this.authService.getCurrentCustomer().subscribe(customer => {
      if (customer) {
        faro.api.setUser({ username: customer.id });
      } else {
        faro.api.resetUser();
      }
    });
  }
}
